import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import {
	Box,
	Divider,
	Link,
	Typography,
	makeStyles,
	Button
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import LoginForm from './Form';
import configService from 'src/services/configService';

const useStyles = makeStyles((theme) => ({
	root: {}
}));

function LoginView() {
	const classes = useStyles();
	const history = useHistory();
	const config = configService.getConfigByKey();

	const handleSubmitSuccess = () => {
		history.push('/app');
	};

	return (
		<>
			<Typography variant="h2" color="textPrimary">
				Accedi
			</Typography>
			<Typography variant="subtitle1" color="textSecondary">
				Accedi a ePortal
			</Typography>
			<Box mt={2}>
				{process.env.NODE_ENV != 'production' && (
					<Alert severity="warning" variant="filled">
						<div>Ambiente di sviluppo</div>
					</Alert>
				)}
			</Box>
			<Box mt={2}>
				{process.env.NODE_ENV != 'production' && (
					<Alert severity="info">
						<div>
							Utilizza <b>fabio.spica@grupposistematica.it</b> e la
							password <b>admin</b>
						</div>
					</Alert>
				)}
			</Box>
			{history?.location?.state?.resetPassSuccess && (
				<Box mt={2}>
					<Alert severity="success">
						Password modificata con successo!
					</Alert>
				</Box>
			)}
			<Box mt={3}>
				<LoginForm onSubmitSuccess={handleSubmitSuccess} />
			</Box>
			
			{config?.appRegistration && (
				<Box my={2}>
					<Button
						fullWidth
						variant="outlined"
						color="primary"
						component={RouterLink}
						to="/auth/registration"
					>
						Registrati
					</Button>
				</Box>
			)}

			<Box mt={2} my={2}>
				<Divider />
			</Box>

			{config?.appForgotPassword && (
				<div>
					<Link
						component={RouterLink}
						to="./lostpassword"
						variant="body2"
						color="textSecondary"
					>
						Password dimenticata?
					</Link>
				</div>
			)}
		</>
	);
}

export default LoginView;
